import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { IDispatchProps, IStateProps, YumGoogleSignIn } from './YumGoogleSignIn'
import { doGoogleSignIn } from './store/GoogleSignInActions'

const mapStateToProps = (state: IGlobalState, { buttonText, isSignUp }: IStateProps): IStateProps => ({
  buttonText,
  isSignUp,
})

const mapDispatchToProps: IDispatchProps = {
  doGoogleSignIn,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoogleSignIn)
